import Model from "../Model";
import tw from "tailwind-styled-components";
import { DeleteBtn, SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteVendor = ({
    setIsDeleteVendor,
    selectedData,
    deletePartnerLoading,
    deletePartnerMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deletePartnerMutate({
            vendorId: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={handleClose}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this vendor?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4 mt-8">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <DeleteBtn
                    onClick={handleDeleteSubmit}
                    disabled={deletePartnerLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deletePartnerLoading ? "Deleting..." : "Delete"}
                </DeleteBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteVendor;